import { createFileRoute } from '@tanstack/react-router';

import { ProviderJobsPage } from '@/features/services/provider/jobs-pages';

export const Route = createFileRoute('/_app/me/services/jobs/')({ component: ProviderJobsPage });
